import clsx from 'clsx'
import { Badge, BadgeProps, TBadgeSize, TBadgeVariant } from '../badge/Badge'

interface BadgeGroupProps {
  data: BadgeProps[]
  size?: TBadgeSize
  variant?: TBadgeVariant
}

export const BadgeGroup = ({ data, size = 'sm', variant = 'outline' }: BadgeGroupProps) => {
  const isWideGap = size === 'md' && variant === 'fill'

  return (
    <div
      className={clsx(
        'flex w-fit cursor-default items-start justify-start',
        isWideGap ? 'gap-[8px]' : 'gap-[4px]',
      )}
    >
      {data.map((props, index) => (
        <Badge key={index} size={size} variant={variant} {...props} />
      ))}
    </div>
  )
}
